import React, { useState } from 'react';
import './App.css'; // Import the new stylesheet
import JobsPage from './pages/Jobs';
import Servers from './pages/Servers';
import Configs from './pages/Configs';

function App() {
    const [page, setPage] = useState('jobs');

    const renderPage = () => {
        switch (page) {
            case 'jobs':
                return <JobsPage />;
            case 'servers':
                return <Servers />;
            case 'configs':
                return <Configs />;
            default:
                return <JobsPage />;
        }
    };

    return (
        <div className="app-container">
            <header className="app-header">
                <h1>Video Transformer</h1>
                <nav className="app-nav">
                    <button onClick={() => setPage('jobs')} className={page === 'jobs' ? 'active' : ''}>Jobs</button>
                    <button onClick={() => setPage('servers')} className={page === 'servers' ? 'active' : ''}>Servers</button>
                    <button onClick={() => setPage('configs')} className={page === 'configs' ? 'active' : ''}>Configs</button>
                </nav>
            </header>
            <main>
                {renderPage()}
            </main>
        </div>
    );
}

export default App;
